import { Component, OnInit, Output, EventEmitter,Input, OnDestroy } from '@angular/core';
import { statusCodes,EwCommonService } from 'ew-common-lib';
import { SelectSessionComponent } from '../../select-session/select-session.component';
import { EventRuningComponent } from '../../event-runing/event-runing.component';
import { EwMaTableListService } from '../../ew-ma-table-list.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmationComponent } from '../../delete-confirmation/delete-confirmation.component';
import { TranslateService } from '@ngx-translate/core';
import { EwTranslateService } from '../../services/ew-translate.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';



interface QueryProps{
  sort_order?: 'asc' | 'desc'
  sort_by?: 'webinar_event_name' | 'created_date'
}

@Component({
  selector: 'ew-webinar-listing-lib',
  templateUrl: './webinar-listing-lib.component.html',
  styleUrls: ['./webinar-listing-lib.component.scss']
})
export class WebinarListingLibComponent implements OnInit{
  /**
   * @description
   * Event id.
   */
  private eventId: string;

  /**
   * @description
   * Webinars data array
   */
  public webinars = [];
  public webinarsCount: any = {};

  public tableLayout = 'grid';
  public eventType = '3'; // All webinars by default
  public page: number = 1;
  public offset: number = 0;
  public limit: number = 12;
  public totalItems: number = 0;
  public search: FormControl = new FormControl('');
  public noWebinarImage:string;
  public search_applied:boolean=false;
  public noSearchImage:string='';

  public sortOptions = [
    {
      label: "Ascending (A-Z)",
      value: { sort_by: "webinar_event_name", sort_order: "asc" },
    },
    {
      label: "Descending (Z-A)",
      value: { sort_by: "webinar_event_name", sort_order: "desc" },
    },
    {
      label: "Oldest on top",
      value: { sort_by: "created_date", sort_order: "asc" },
    },
    {
      label: "Newest on top",
      value: { sort_by: "created_date", sort_order: "desc" },
    },
  ];
  public sortQuery = this.sortOptions[3].value

  /**
   * @description
   * Language
   */
   @Input() default_lang: string = 'en';

  public showSectionLoader: boolean = true;
  @Output() webinarDetail: EventEmitter<any> = new EventEmitter();
  @Output() addNewWebinar: EventEmitter<any> = new EventEmitter();
  private readonly ACTIVE_TAB_ID = "ew_overiew_page_tab"
  eventDetails: any;

  /**
   * @description
   * Inject services to use in this component.
   */

  constructor(
    private tableListService: EwMaTableListService,
    public dialog: MatDialog,
    private ewTranslateService: EwTranslateService,
    public translate: TranslateService,
    private ewCommonService: EwCommonService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.translate.setDefaultLang(this.default_lang);
    this.translate.use(this.default_lang).subscribe(() => {
      this.ewTranslateService.init();

    });
    const tabId = localStorage.getItem(this.ACTIVE_TAB_ID)
    if (tabId) this.eventType = tabId;
    let direction = this.route.snapshot.queryParamMap.get("back");
    if(direction=="true" && localStorage.getItem("pageState")){
      let pagestate = JSON.parse(localStorage.getItem("pageState"));
      this.page = pagestate.page;
      this.limit = pagestate.limit;
      this.offset = pagestate.offset;
      this.eventType = pagestate.event_type;
      this.search.patchValue(pagestate.search);
    }
    this.getWebinars('init');
    this.applyStyle();
    this.noWebinarImage = this.tableListService.getImageCDNEndpoint() + 'assets/images/no-webinar-listing.svg';
    this.search.valueChanges.pipe(distinctUntilChanged(), debounceTime(1000)).subscribe((searchTerm: string) => { 
      this.resetLocalStorage();
      this.page = 1;
      this.offset = 0;
      this.getWebinars('');
    })
  }

saveActiveTab(){
    localStorage.setItem(this.ACTIVE_TAB_ID, this.eventType);
    this.resetLocalStorage();
    this.applyStyle();
}

public resetLocalStorage(){
  localStorage.removeItem("pageState");
}

private readonly eventTypeBodyClass = {
  "1": "live-event",
  "0": "simulated-event",
  "2": "evergreen-event"
}

private applyStyle(){
  const eventType = this.eventType
  const appliedClassses = Object.values(this.eventTypeBodyClass)
    document.body.classList.remove(...appliedClassses)
    if (eventType == '3' || eventType == '4') {
      document.body.classList.add(this.eventTypeBodyClass['1']);
    } else { 
      document.body.classList.add(this.eventTypeBodyClass[eventType])
    }

  switch(eventType){
    case "0":
      this.noSearchImage = this.tableListService.getImageCDNEndpoint()+'assets/images/no-data-found-simulated.svg';
      break;
    case "2":
      this.noSearchImage = this.tableListService.getImageCDNEndpoint()+'assets/images/no-data-found-evergreen.svg';
      break;
    default :
    this.noSearchImage = this.tableListService.getImageCDNEndpoint()+'assets/images/no-data-found.svg';
    break;

  }


}




  /**
   * @description
   * Get webinars list
   */
  getWebinars(calledFrom:string) {
    let selectedDomain = localStorage.getItem('ew_user_domain');
    if(this.eventType=='4' && this.totalItems==1 && calledFrom=='unarchive'){
      this.eventType = '3';
    }
    const model = {
      limit: this.limit,
      offset: this.offset,
      event_type: this.eventType,
      search: this.search.value,
      domain_id: selectedDomain,
      sort_order: this.sortQuery.sort_order,
      sort_by: this.sortQuery.sort_by,
      page: this.page
    };
    this.showSectionLoader = true;

    localStorage.setItem("pageState",JSON.stringify(model));

    this.ewCommonService.addPopupCustomClass("full-screen-black-dialog");
    this.tableListService.getWebinars(model).subscribe(
      (response: any) => {
        this.ewCommonService.removePopupCustomClass("full-screen-black-dialog");
        this.showSectionLoader = false;
        if (response.status.code == statusCodes.SUCCESS) {
          this.webinars = response.data.webinars;
          if(this.search.value == ''){
            this.webinarsCount = response.data.countData;
            this.tableListService.evenstsCount.next(this.webinarsCount);
            localStorage.setItem('EVENTS_COUNT', JSON.stringify(this.webinarsCount));
            if (this.eventType == '1') this.totalItems = this.webinarsCount.live;
            if (this.eventType == '0') this.totalItems = this.webinarsCount.simulated_live;
            if (this.eventType == '2') this.totalItems = this.webinarsCount.evergreen;
            if (this.eventType == '3') this.totalItems = this.webinarsCount.all_events;
            if (this.eventType == '4') this.totalItems = this.webinarsCount.archived;
            this.search_applied = false;
          } else {

            let webinarsCountSearch = response.data.countData;
            //this condition is for assigning  count of each event types when search is applied.
            if (this.tableListService.evenstsCount.value) {
              this.webinarsCount = this.tableListService.evenstsCount.value;
            } else { 
              this.webinarsCount = JSON.parse(localStorage.getItem('EVENTS_COUNT'));
            }
            switch(this.eventType){
              case '1' :
                this.webinarsCount.live = webinarsCountSearch.live;
                this.totalItems = this.webinarsCount.live;
                break;
              case '0' :
                this.webinarsCount.simulated_live = webinarsCountSearch.simulated_live;
                this.totalItems = this.webinarsCount.simulated_live;
                break;
              case '2' :
                this.webinarsCount.evergreen = webinarsCountSearch.evergreen;
                this.totalItems = this.webinarsCount.evergreen;
                break;
              case '3' :
                this.webinarsCount.all_events = webinarsCountSearch.all_events;
                this.totalItems = this.webinarsCount.all_events;
                break;
              case '4' :
                this.webinarsCount.archived = webinarsCountSearch.archived;
                this.totalItems = this.webinarsCount.archived;
                break;
            }
            this.search_applied = true;
          }
        } else {
          console.log('Error in api request');
          this.resetRecords();
        }
      },
      (error) => {
        console.log('error', error);
        this.resetRecords();
      }
    );
  }

  pageChanged(page: number) {
    this.page = page;
    this.offset = (this.page -1) * this.limit + 1;
    this.getWebinars('pagination');
  }

  resetRecords() {
    this.page = 1;
    this.webinars = [];
    this.totalItems = 0;
  }

  selectWebinar(webinar:any): void {
    if(webinar.status !== "0")
    this.webinarDetail.emit(webinar.webinar_id);
  }

  addWebinar(webinar:any): void {
    this.addNewWebinar.emit(webinar);
  }

  openNewTab(url):void{
    window.open(url, '_blank');
  }

  /*
  * Function archive an event
  */
  archiveEvent(webinar_id, status): void {

    const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
      maxWidth: '500px',
      width: '100%',
      panelClass: 'confrimation-delete'
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        const model = {
          webinar_id: webinar_id,
          status: status,
        };
        this.showSectionLoader = true;
        this.tableListService.archiveEvent(model).subscribe(
          (response: any) => {
            if (response.status.code == statusCodes.SUCCESS) {
              this.getWebinars('archive');
            }
          },
          (error) => {
            console.log('error', error);
            this.showSectionLoader = false;
          }
        )
      }
    });

  }

  /**
 * Function to unarchive an event
 */
 unarchive(webinar_id,status){

  const model = {
    webinar_id: webinar_id,
    status: status,
  };
  this.showSectionLoader = true;
  this.tableListService.archiveEvent(model).subscribe(
    (response: any) => {
      if (response.status.code == statusCodes.SUCCESS) {
        this.getWebinars('unarchive');
      }
    },
    (error) => {
      console.log('error', error);
      this.showSectionLoader = false;
    }
  )

}

/**
 * Function to go live for live event
 */

goLive(webinar_id,domain_id):void{
  const model = {
    webinar_id:webinar_id,
    domain_id:domain_id,
  };
  var newEventData = {
    webinar_id:webinar_id,
    domain_id:domain_id,
  };
  this.showSectionLoader = true;
  this.tableListService.goLive(model).subscribe(
    (response: any) => {
      if (response.status.code == statusCodes.SUCCESS) {
        switch (response.data.status) {
          case "webinar_already_running":
            window.location.href = response.data.url;
            break;
          case "another_webinar_running":
            console.log(response);
            this.showSectionLoader = false;
            let modelData = {'sessionLink':response.data.url,'event_name':response.data.webinar_name, 'responseData':response.data, 'new_event': newEventData };
            const dialogRefRunning = this.dialog.open(EventRuningComponent, {
              maxWidth: '480px',
              width:'100%',
              panelClass: 'runing-event',
              data: { sessionData: modelData}
            });

            dialogRefRunning.afterClosed().subscribe((result) => {
            });
            break;
          case "session_list":
            this.showSectionLoader = false;
            let sessionListData = {'sessionList':response.data.session,'webinar_id':webinar_id,'domain_id':domain_id,'golive_url':response.data.golive_url};
            if(response.data.session.length == 1 && response.data.session[0].new_session == true){
              let url = sessionListData.golive_url+"?webinar_id="+sessionListData.webinar_id+"&did="+sessionListData.domain_id+"&sid="+response.data.session[0].session_id;
              console.log(url);
              window.location.href = url;
            } else {
              const dialogRef = this.dialog.open(SelectSessionComponent, {
                maxWidth: '600px',
                width:'100%',
                panelClass: 'session-event-select',
                data: { sessionData: sessionListData}
              });

              dialogRef.afterClosed().subscribe((result) => {
              });
            }
            break;
          default:
            console.log(response.data.status);
        }
      }
    },
    (error) => {
      console.log('error', error);
      this.showSectionLoader = false;
    }
  )
}

  /**
   * @description
   * Formats Date values into Locale format.
   * @returns {string} Display date in local format.
   */
  // convertDateToLocalString(date: string): string {
  //   if (date.length) {
  //     var fullDate = moment(date);
  //     return fullDate.format('dddd, MMMM Do YYYY [@] hh:mm A');
  //   } else {
  //     return '';
  //   }
  // }
  /*
  Get cdn path from env file
  */
  V2CDN():any  {
    return this.tableListService.getV2CDN();
  }

  public onSortChange($event) {
    const value = $event.value;
    this.sortQuery = value;
    this.getWebinars('onSortChange');
  }



}
